import BookSpine from "@/components/BookSpine";

export default function ShelfRow({ group, books, onOpenDetail }) {
  return (
    <section className="plank-section" data-testid={`shelf-${group.value}`}>
      <div className="mb-3 flex items-baseline gap-3 px-1">
        <span className="shelf-label">{group.label}</span>
        <span className="shelf-label text-[#2B328C]/70">· {group.range}</span>
        <span className="ml-auto text-[10px] uppercase tracking-wider text-[#0E232E]/50 font-semibold">
          {books.length} {books.length === 1 ? "book" : "books"}
        </span>
      </div>

      <div className="relative">
        <div className="shelf-cabinet">
          {/* Books inside the cabinet */}
          <div
            className="flex items-end gap-3 md:gap-4 overflow-x-auto md:overflow-visible md:flex-wrap hide-scrollbar pb-0 min-h-[245px] relative"
            data-testid={`shelf-row-${group.value}`}
          >
            {books.length === 0 ? (
              <p className="text-[#0E232E]/40 italic text-sm py-6">
                This shelf is waiting for its first book.
              </p>
            ) : (
              books.map((b) => <BookSpine key={b.id} book={b} onOpenDetail={onOpenDetail} />)
            )}
          </div>
          {/* Floor / shelf plank */}
          <div className="shelf-floor" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
